
import React from "react";
import { Helmet } from "react-helmet-async";
import { Navbar, Footer, Breadcrumbs } from "../../components/shared";
import "../general/General.css";

const LoginAwaitingLink = () => {

    return (
        <>
            <Navbar />
            <Helmet>
                <title>ஸ்ரீ பொன்னாச்சி அம்மன் திருக்கோவில்கள் | உள்நுழைவு இணைப்பிற்காக காத்திருக்கிறது</title>
                <link rel="canonical" href="/auth/login" />
            </Helmet>
            <div className="general_parent">
                <div className="general_container">
                    <div className="general_body">
                        <Breadcrumbs />
                        <h1>உள்நுழைவு இணைப்பிற்காக காத்திருக்கிறது</h1>
                        <br />
                        <h4>சரிபார்ப்பு மின்னஞ்சல் அனுப்பப்பட்டது. பதிவை முடிக்க உங்கள் மின்னஞ்சலைச் பார்க்கவும்...</h4>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default LoginAwaitingLink;
